function getItemName(identifier) {
  return 'mgconf_' + identifier
}

function _get(identifier) {
  return sessionStorage.getItem(getItemName(identifier))
}

function storageGet(identifier, property = null) {
  let data = _get(identifier)
  if (typeof data === 'undefined' || data === null) {
    return undefined
  } else {
    data = JSON.parse(data)
  }

  return property === null ? data : data[property]
}

function storageSet(identifier, property, value) {
  let data = _get(identifier)
  if (typeof data === 'undefined' || data === null) {
    data = {}
  } else {
    data = JSON.parse(data)
  }
  data[property] = value
  sessionStorage.setItem(getItemName(identifier), JSON.stringify(data))
}

function storageClear(identifier) {
  sessionStorage.removeItem(getItemName(identifier))
}

export { storageGet, storageSet, storageClear }
